/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import config from 'loracfg';

const HideIf = (props) => {
  let hide = false;
  const condition = props.if;
  if (_.isString(condition)) {
    const [key, value] = condition.split(':').map(s => (s.trim()));
    if (key === 'profile' && config.profile === value) {
      hide = true;
    }
  } else if (_.isFunction(condition)) {
    hide = condition();
  } else {
    hide = condition;
  }

  if (hide) {
    return null;
  }
  return props.children;
};

export default HideIf;




// WEBPACK FOOTER //
// ./src/components/HideIf/index.jsx